import http from "@/services/http";
import { featureFlags } from "@/config/env";
import { mockManager } from "@/services/mock";

// 媒体文章数据项
export interface MediaArticleItem {
  title: string;
  url: string;
  rate: number; // AI引用占比
}

// 媒体文章响应数据
export interface MediaArticleResponse {
  code: number;
  message: string;
  data: {
    list: MediaArticleItem[];
    total: number;
    page: number;
    pageSize: number;
  };
}

// 媒体文章请求参数
export interface MediaArticleParams {
  domainId?: string;
  brandId?: string;
  categoryId?: string;
  modelId?: string;
  days?: number;
  page: number;
  pageSize: number;
}

/**
 * 媒体文章 API 服务
 */
export const mediaArticleApi = {
  /**
   * 获取媒体引用文章列表
   * @param params 请求参数
   */
  async getMediaArticles(
    params: MediaArticleParams
  ): Promise<MediaArticleResponse> {
    // 启用mock数据时使用模拟数据
    if (featureFlags.enableMock) {
      const mockResponse = await mockManager.getMediaArticles(params);
      // 对mock数据做容错处理，确保list始终为数组
      const mockData = mockResponse as MediaArticleResponse;
      if (mockData.data && mockData.data.list === null) {
        mockData.data.list = [];
      }
      return mockData;
    }

    try {
      // 发起真实API请求
      const response = await http.get<MediaArticleResponse>(
        "data/cite/media/article",
        {
          params: {
            ...params,
            // 过滤掉undefined的参数
            ...Object.fromEntries(
              Object.entries(params).filter(([_, v]) => v !== undefined)
            ),
          },
        }
      );

      // 对返回的数据做容错处理，确保list始终为数组
      const responseData = response.data;
      if (responseData.data && responseData.data.list === null) {
        responseData.data.list = [];
      }

      return responseData;
    } catch (error) {
      console.error("获取媒体引用文章失败:", error);
      // 出错时回退到mock数据
      const mockResponse = await mockManager.getMediaArticles(params);
      // 对mock数据做容错处理，确保list始终为数组
      const mockData = mockResponse as MediaArticleResponse;
      if (mockData.data && mockData.data.list === null) {
        mockData.data.list = [];
      }
      return mockData;
    }
  },
};

export default mediaArticleApi;
